import { envConfig as developer } from './developer';
import { envConfig as test } from './test';
import { envConfig as production } from './production';
import { envConfig as rollout } from './rollout';
import { envConfig as local } from './local';

export function configureEnvironment() {
  const hostname = window && window.location && window.location.hostname;

  if (hostname.startsWith("dotnethml.hermespardini.com.br")) {
    return test
  } else if (hostname.startsWith("rollout.mypardini.com.br")) {
    return rollout
  } else if (hostname.startsWith("www.mypardini.com.br")) {
    return production
  } else if (hostname.startsWith("www.mypardinilocal.com.br")) {
    return local
  } else {
    return developer
  }
}
